import type { TFunction } from 'i18next';
import { z } from 'zod';

import { AddressSectionSchema } from '@/features/DataChangeRequest/_schemas/AddressSection.validation';
import { AffiliationsSectionSchema } from '@/features/DataChangeRequest/_schemas/AffiliationsSection.validation';
import { AttachmentsSectionSchema } from '@/features/DataChangeRequest/_schemas/AttachmentsSection.validation';

import { ContactSectionSchema } from './HcoSchemas/ContactSection.validation';
import { NameSectionSchema } from './HcoSchemas/NameSection.validation';
import { OrganizationalSectionSchema } from './HcoSchemas/OrganizationalSection.validation';
import { NewEntityCountryIdSchema } from './NewEntityCountryId.validation';

export const HcoDcrSchema = (t: TFunction) => {
	return NameSectionSchema(t)
		.safeExtend(OrganizationalSectionSchema(t).shape)
		.safeExtend(ContactSectionSchema().shape)
		.safeExtend(AddressSectionSchema(t).shape)
		.safeExtend(AffiliationsSectionSchema(t).shape)
		.safeExtend(NewEntityCountryIdSchema().shape)
		.safeExtend(AttachmentsSectionSchema().shape)
		.extend({
			notes: z.string().trim().nullish(),
			isThirdPartyDataConfirmed: z.boolean().nullish()
		})
		.refine(
			data => {
				const hasAddress = data.addresses && data.addresses.length > 0;
				const hasAffiliation = data.parenthcos && data.parenthcos.length > 0;
				return hasAddress || hasAffiliation;
			},
			{
				message: t
					? t('Affiliation or Address required')
					: 'Affiliation or Address required',
				path: ['addresses']
			}
		);
};

export type HcoDcrValuesIn = z.input<ReturnType<typeof HcoDcrSchema>>;
export type HcoDcrValuesOut = z.output<ReturnType<typeof HcoDcrSchema>>;
